import * as formats from "../../../../common/formats";

require('select2');
require('tempusdominus-bootstrap-4');

var baseDatepickerOpts = {
    locale: 'ja',
    dayViewHeaderFormat: 'YYYY年 M月',
    format: 'YYYY/MM/DD',
};

// 新規契約作成
$(() => {
    if (document.getElementById('agent-contract-edit') != null) {
        setupLabels();
        setClient();
        setupPartners();
        setUpAgents();
        setUpManageClient();
        setupCompanyUsers();
        setupCompanies();
        setupReportType();

        $('.date .datepicker').datetimepicker(baseDatepickerOpts);
        setupMonthlyDatepicker();
        setupMonthlyConditionTable();
        setupAdditionalCostTable();
        setupRelatedContractsList();

        // クライアントがPRO BASEを使わないルート
        $('.unused').on('click', function(e) {
            var element = $('#unused');
            element.css('display', 'flex');
        });
        if ($('input[name="clientType"]:checked').val()=='2') {
            var element = $('#unused');
            element.css('display', 'flex');
        }

        $('#common_modal').on('show.bs.modal', function (event) {
            var el = $(event.relatedTarget);
            var title = el.data('title').length? el.data('title'): "";
            var message = el.data('message').length? el.data('message'): "";
            var exec = el.data('exec').length? el.data('exec'): "はい";
            var cxl = el.data('cxl').length? el.data('cxl'): "キャンセル";
            var modal = $(this);
            modal.find('.modal-title').text(title);
            modal.find('.modal-body').text(message);
            modal.find('.modal-exec').text(exec);
            modal.find('.modal-cxl').text(cxl);

            $('.modal-exec').click(function(event) {
                // 途中保存のフラグを立てる
                $('#form').append('<input name="save" type="hidden" value="true" />');
                $('.js-data-price').each(function(i, e) {
                    $(e).val(formats.convertNum($(e).val()));
                });
                $('.js-data-hour').each(function(i, e) {
                    $(e).val(formats.convertNum($(e).val()));
                });
                $('#form').submit();
            });
        })
    }
});

// パートナー一覧
function setupPartners() {
    setupSelect2('.js-partners', '/agent/contract/new/findPartners', 'ユーザーを選択して下さい', templateUserResultItem, templateCompanyUserSelectionItem);
}

// エージェント一覧
function setUpAgents()
{
    setupSelect2('.js-agents', '/agent/contract/new/findAgents', 'ユーザーを選択して下さい', templateUserResultItem, templateUserSelectionItem);
}

// クライアント一覧（自社管理）
function setUpManageClient() {
    setupSelect2('.js-manage-client', '/agent/contract/new/findManageClient', 'ユーザーを選択して下さい', templateUserResultItem, templateCompanyUserSelectionItem);
}

// クライアント一覧
function setClient()
{
    let contract_id = $('input[name="id"]');
    setupSelect2('.js-client', '/agent/contract/edit/findClient/'+contract_id.val(), 'ユーザーを選択して下さい', templateUserResultItem, templateCompanyUserSelectionItem);
}

// 企業一覧
function setupCompanies()
{
    setupSelect2('.js-companies', '/agent/contract/new/findCompanies', '企業名を入力して下さい', templateUserResultItem, templateCompanyUserSelectionItem);
}

// 企業ユーザー一覧
function setupCompanyUsers() {
    setupSelect2('.js-company-users', '/agent/contract/new/findAgents', 'ユーザーを選択して下さい', templateUserResultItem, templateUserSelectionItem);
    setupSelect2('.js-viewable-users', '/agent/contract/new/findAgents', 'ユーザーを選択して下さい', templateUserResultItem, templateUserSelectionItem);
    updateWorkflowUser();
}

// ラベル
function setupLabels() {
    $('#labels').select2({
        tags: true,
        placeholder: 'ラベルを選択して下さい',
        dropdownAutoWidth: true,
        width: 'resolve',
        allowClear: true,
    });
    var params = $('#labels').data('init');
    if (params) {
        // paramsが1件の場合、数値になってしまうのでtoString()する
        $('#labels').val(params.toString().split(',')).trigger('change');
    }
}

function setupSelect2(selector, url, placeholder, templateResult, templateSelection) {
    var element = $(selector);

    var select2 = element.select2({
        tags: true,
        placeholder: placeholder,
        dropdownAutoWidth: true,
        width: 'resolve',
        allowClear: true,
        ajax: {
            type: 'POST',
            async: true,
            url: url,
            headers: {
            	'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: function (params) {
                var query = {
                    search: params.term,
                }
                return query;
            },
            minimumInputLength: 2,
            delay: 200,
            cache: true,
            processResults: function(data) {
                let target = this.$element;
                if (data.results.length == 0 && target.val()) {
                    // 選択中の場合で検索結果が無ければ、選択中の要素を追加する
                    data.results = [{ id:target.val(), text:target.find('option:selected').text() }]
                }
                return data;
            },
        },
        templateResult: templateResult,
        templateSelection: templateSelection
    });
    var initItem = element.data('init');
    if (initItem) {
        // 初期値を設定
        if (initItem.length) {
            initItem.forEach(function(item) {
                var opt = new Option(templateSelection(item).html(), item.id, false, false);
                element.append(opt);
            });
            element.val(initItem.map((item)=>item.id)).trigger('change');
        } else {
            var opt = new Option(templateSelection(initItem).html(), initItem.id, false, false);
            element.append(opt);
            element.val(initItem.id).trigger('change');
        }
    }
    // 未選択等のエラー時
    var isInvalid = element.hasClass('is-invalid');
    if (isInvalid) {
        select2.data('select2').$container.addClass('is-invalid');
    }
}

// ユーザー選択のアイテムテンプレート
function templateUserResultItem(data) {
    if (!data.id || data.loding) {
        // group or Searching...
        return $(`<span><b>${data.text}</b></span>`);
    }

    let view = null;
    if (data.avatar_path) {
        view = $(`<span><img src='/${data.avatar_path}' class="rounded-circle" width="30px"> ${data.text}</span>`);
    } else {
        view = $(`<span>${data.text}</span>`);
    }
    return view;
}

// ユーザー選択の選択時表示テンプレート
function templateUserSelectionItem(data) {
    if (!data.id || data.loding) {
        // placeholder or Searching...
        return $(`<span>${data.text}</span>`);
    }

    let view = null;
    if (data.avatar_path) {
        view = $(`<span><img src='/${data.avatar_path}' class="rounded-circle" width="30px"> ${data.text}</span>`);
    } else {
        view = $(`<span>${data.text}</span>`);
    }
    return view;
}

// ユーザー選択の選択時表示テンプレート(社名付)
function templateCompanyUserSelectionItem(data) {
    if (!data.id || data.loding) {
        // placeholder or Searching...
        return $(`<span>${data.text}</span>`);
    }

    let view = null;
    if (data.avatar_path) {
        view = $(`<span><img src='/${data.avatar_path}' class="rounded-circle" width="30px"> ${data.company_name??''} ${data.text}</span>`);
    } else {
        view = $(`<span>${data.company_name??''} ${data.text}</span>`);
    }
    return view;
}

// 除外リスト取得
function getExclusions(selector) {
    // 更新するdata属性はjQueryでは取得できないためネイティブJSで取得する
    let ele = document.querySelector(selector);
    let json = ele? ele.getAttribute('data-exclusions'): null;
    return json? JSON.parse(json): [];
}

// 除外リスト設定
function setExclusions(selector, val) {
    let ele = document.querySelector(selector);
    if (ele) {
        let json = ele.setAttribute('data-exclusions', JSON.stringify(val));
    }
}

// ワークフロー更新時、閲覧可能ユーザーの除外ユーザーを更新する
function updateWorkflowUser() {
    let exclusions = [];
    let selector = '.js-viewable-users';
    setExclusions(selector, exclusions);
    let element = $(selector);
    let values = element.val();
    if (values) {
        values = values.map(i=>parseInt(i));
        values = values.filter(id => !exclusions.includes(id));
        element.val(values).trigger('change');
    }
}

// 月別条件datepicker構築
function setupMonthlyDatepicker() {
    var monthOpts = {
        ...baseDatepickerOpts,
        viewMode: 'years',
        format: 'YYYY/MM',
    };
    $('.month .datepicker').datetimepicker(monthOpts);
    $('.datepicker').blur(function() {
        var term_start = $('#termStart').val();
        var term_end = $('#termEnd').val();
        let term_additional_month = [];
        $('input[name="additionalMonth[]"]').each(function(index, element) {
            term_additional_month.push(element.value);
        });

        $('.datepicker').datetimepicker('hide');

        $('input[name="additionalMonth[]"]').each(function(index, element) {
            $('#additionalMonth' + index).val(term_additional_month[index]);
        });
        $('#termStart').val(term_start);
        $('#termEnd').val(term_end);
    });
}

// 月別条件テーブル構築
function setupMonthlyConditionTable() {
    $(document).on("click", '.js-remove-monthly-condition', function(e) {
        e.preventDefault();
        let tr = $('.js-monthly-table-body .js-data-row');
        if (tr.length > 1) {
            $(this).closest('.js-data-row').remove();
        } else {
            // 最後の1行の時は値のみクリアする
            $(this).closest('.js-data-row').find('input').each(function(i, element) {
                $(element).val('');
            });
        }
    });
    $(document).on("click", '.js-add-monthly-condition', function(e) {
        e.preventDefault();
        let template = $('.js-monthly-table-body .js-data-row').last();
        let row = template.clone();
        let id = row.data('id') + 1;
        row.attr('data-id', id);
        $(row.find('input').get(0)).attr('id', 'month' + id);
        row.find('.js-datepicker-set-target').data('target', '#month' + id);
        $($(row).find('input')).removeClass('is-invalid');
        $('.js-monthly-table-body').append(row);
        setupMonthlyDatepicker();
    });
}

// 追加費用テーブル構築
function setupAdditionalCostTable() {
    $(document).on("click", '.js-remove-additional-cost', function(e) {
        e.preventDefault();
        let tr = $('.js-additional-cost-table-body .js-data-row');
        if (tr.length > 1) {
            $(this).closest('.js-data-row').remove();
        } else {
            // 最後の1行の時は値のみクリアする
            $(this).closest('.js-data-row').find('input').each(function(i, element) {
                $(element).val('');
            });
        }
    });
    $(document).on("click", '.js-add-additional-cost', function(e) {
        e.preventDefault();
        let template = $('.js-additional-cost-table-body .js-data-row').last();
        let row = template.clone();
        let id = row.data('id') + 1;
        row.attr('data-id', id);
        $(row.find('input').get(0)).attr('id', 'additionalMonth' + id);
        row.find('.js-datepicker-set-target').data('target', '#additionalMonth' + id);
        $($(row).find('input')).removeClass('is-invalid');
		row.find('input').each(function(){
			$(this).val('');
		});
        $('.js-additional-cost-table-body').append(row);
        setupMonthlyDatepicker();
    });
}

// 関連契約リスト構築
function setupRelatedContractsList() {
    var element = $('.js-select-contract');
    setupContractSelector(element, '/agent/contract/new/findContracts');

    const relatedContracts = $('#relatedContracts').val();
    if (relatedContracts) {
        const template = $('#related-list-item');
        relatedContracts.split(',').forEach((param) => {
            let data = param.split(':');
            const item = createRelatedItem(data[0], data[1], data[2]);
            $('.js-related-list').append(item);
        });
    }

    $('.js-add-related-contract').on('click', function(e) {
        $.ajax({
            url: '/agent/contract/new/getContract',
            type: 'POST',
            data: { id: $('#contractSelector').val() },
            dataType: 'json',
            timespan: 1000
        }).done(function(data, textStatus, jqXHR) {
            if (data.id) {
                const item = createRelatedItem(data.id, data.no, data.name);
                $('.js-related-list').append(item);
                let values = $('#relatedContracts').val().split(',');
                const result = values.find(item => item.split(':')[0] == data.id);
                if (!result) {
                    values.push(data.id + ':' + data.no + ':' + data.name);
                    $('#relatedContracts').val(values.join(','));
                }
            }
        }).fail(function(jqXHR, textStatus, errorThrown ) {
        }).always(function(){
        });
    });

    $(document).on("click", '.js-remove-related-contract', function(e) {
        e.preventDefault();
        let target = $(this).closest('.js-contract-item');
        if (target.length) {
            let id = target.data('id');
            let values = $('#relatedContracts').val().split(',');
            const results = values.filter(item => item.indexOf(id + ':') != 0);
            $('#relatedContracts').val(results.join(','));
            target.remove();
        }
    });
}

// 関連契約アイテム作成
function setupContractSelector(element, url) {
    element.select2({
        tags: true,
        placeholder: '契約名を入力して下さい',
        dropdownAutoWidth: true,
        width: 'resolve',
        allowClear: true,
        ajax: {
            type: 'POST',
            async: true,
            url: url,
			headers: {
				'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
			},
            data: function (params) {
                var query = {
                    search: params.term,
                }
                return query;
            },
            minimumInputLength: 2,
            delay: 200,
            cache: true,
            processResults: function(data) {
                return {
                    results: $.map(data, function (item) {
                        return {
                            id: item.id,
                            text: item.name,
                        }
                    })
                }
            }
        }
    });
    var params = element.data('init');
    if (params) {
        let values = [];
        params.split(',').filter(item => {
            let val = item.split(':');
            var opt = new Option(val[1], val[0], false, false);
            element.append(opt);
            values.push(val[0]);
        });
        element.val(values).trigger('change');
    }
}

// 関連契約アイテム作成
function createRelatedItem(id, no, name) {
    const content = $('#related-list-item')[0].content;
    const fragment = document.createDocumentFragment();
    let clone = document.importNode(content, true);
    let item = $('.js-contract-item', clone);
    item.attr('data-id', id);
    item.children('.js-contract-no').text(no);
    item.children('.js-contract-name').text(name);
    fragment.appendChild(clone);
    return fragment;
}

// 請求形式
function setupReportType() {
    $('.js-reportType').on('change', function(e) {
        updateAdvisoryBlock();
    });
    updateAdvisoryBlock();
}

function updateAdvisoryBlock() {
    let reportType = $('.js-reportType').val();
    switch (reportType) {
        case '1':
            $('.advisory-collapse').show();
            break;
        case '2':
            $('.advisory-collapse').hide();
            break;
    }
}
